var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"padding-top":"0"},attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center",staticStyle:{"padding-bottom":"10px"},attrs:{"cols":"12"}},[_c('v-img',{staticClass:"hero-image2",attrs:{"src":_vm.bannerImage,"aspect-ratio":"1","contain":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }